import { Color, DefaultValue, getDefaultTransition, getShadow, Spacing } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { InputSize } from '../Form'

interface SelectIconWrapperProps {
  inputSize?: InputSize
}

export const SelectIconWrapper = styled.span<SelectIconWrapperProps>`
  display: flex;
  align-items: center;
  width: 40px;
  height: stretch;
  margin-left: 20px;
  padding: ${Spacing.S8} ${Spacing.S12};
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  cursor: pointer;
`

const headingStyles = css`
  border-radius: 0;
  position: sticky;
  top: 0;
  background-color: ${Color.White};
  cursor: auto;
`
interface SelectListItemWrapperProps {
  isHeading?: boolean
  selected?: boolean
  withFooter?: boolean
}

type SelectItemStylesProps = Omit<SelectListItemWrapperProps, 'isHeading'>

const selectItemStyles = ({ selected, withFooter }: SelectItemStylesProps) => css`
  background-color: ${selected ? Color.Purple50 : Color.White};
  cursor: pointer;
  ${getDefaultTransition('background-color')};

  &:last-of-type {
    margin-bottom: ${withFooter ? Spacing.S8 : 0};
  }

  ${!selected &&
  css`
    &:hover {
      background-color: ${Color.Grey100};
    }
  `};
`

export const SelectListItemWrapper = styled.li<SelectListItemWrapperProps>`
  padding: ${Spacing.S12} ${Spacing.S16};
  border-radius: ${DefaultValue.BorderRadius};

  ${({ isHeading, selected, withFooter }) => (isHeading ? headingStyles : selectItemStyles({ selected, withFooter }))}
`

export const SelecttListWrapper = styled.div`
  padding: ${Spacing.S8};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.White};
  ${getShadow('elevatedStrong')};
  text-align: left;
  overflow: hidden;
`
